import { render, staticRenderFns } from "./box-contents-parent.vue?vue&type=template&id=7c4c59ee&"
import script from "./box-contents-parent.vue?vue&type=script&lang=js&"
export * from "./box-contents-parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports